'use client';

import { Page_Pagebuilder_Blocks_Nav } from '@/graphql/generated/graphql';
import { useEffect, useRef, useState } from 'react';
import { trackLinkClick } from '../../../utils/tracking';

const NavBlock = ({ links }: Page_Pagebuilder_Blocks_Nav) => {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFixed(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      {
        threshold: 0,
      },
    );

    observer.observe(sentinel);

    return () => observer.disconnect();
  }, []);

  if (!links?.length) return null;
  return (
    <>
      <div ref={sentinelRef} className="h-px" aria-hidden="true" />

      <nav
        aria-label="Hoppa till avsnitt"
        className={`z-[51] w-full bg-white ${
          isFixed ? 'fixed inset-x-0 top-0 shadow' : 'relative'
        }`}
      >
        <div className="relative">
          <div
            className="
              touch-pan-x overflow-x-auto overscroll-x-contain
              scroll-smooth [scrollbar-width:none]
              [&::-webkit-scrollbar]:hidden
            "
          >
            <ul
              className="
                flex min-h-14 w-max min-w-full items-center gap-8 px-6
                sm:gap-10
                xl:justify-center xl:gap-20 xl:px-8
              "
            >
              {links.map((link, index) => (
                <li key={`${link.linkId}-${index}`} className="shrink-0">
                  <a
                    onClick={trackLinkClick}
                    className="
                      whitespace-nowrap text-base font-bold text-black
                      no-underline transition hover:text-gray-500
                    "
                    href={
                      link.linkId.includes('http')
                        ? link.linkId
                        : `#${link.linkId}`
                    }
                  >
                    {link.linkText}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="
              pointer-events-none absolute inset-y-0 left-0 w-6
              bg-gradient-to-r from-white to-transparent
              xl:hidden
            "
            aria-hidden="true"
          />

          <div
            className="
              pointer-events-none absolute inset-y-0 right-0 w-6
              bg-gradient-to-l from-white to-transparent
              xl:hidden
            "
            aria-hidden="true"
          />
        </div>
      </nav>

      {isFixed && <div className="h-14" aria-hidden="true" />}
    </>
  );
};

export default NavBlock;
